import { ORDER_TYPE } from '@spartacus/order/root';
import { CustomCheckoutActions } from "../actions";
import { OrderTypesState } from '../custom-checkout-state';


export const initialState: OrderTypesState = {
  selected: ORDER_TYPE.PLACE_ORDER,
};

export function reducer(
  state = initialState,
  action: CustomCheckoutActions.OrderTypesActions | CustomCheckoutActions.CheckoutAction
): OrderTypesState {
  switch (action.type) {
    case CustomCheckoutActions.SET_ORDER_TYPE: {
      return {
        ...state,
        selected: action.payload,
      };
    }

    case CustomCheckoutActions.CLEAR_CHECKOUT_DATA: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
